module.exports = __webpack_public_path__ + "img/Abfahrtskontrolle.f72c2c73.svg";